import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#loan-payment-2-app', App);
